import { ReactNode } from "react";
import style from "./CustomTabsV3.module.scss";
import classNames from "classnames";
import { Tabs } from "@chakra-ui/react";
import Typhography from "../Typhography/Typhography";

export interface ICustomTabsV3 {
  tabs: { label: string; icon?: ReactNode; value: any; hasError?: boolean }[];
  defaultValue?: Tabs.RootProps["defaultValue"];
  value?: Tabs.RootProps["value"];
  onValueChange?: Tabs.RootProps["onValueChange"];
  lazyMount?: Tabs.RootProps["lazyMount"];
  unmountOnExit?: Tabs.RootProps["unmountOnExit"];
  variant?: Tabs.RootProps["variant"];
  className?: string;
  classNameList?: string;
  children?: ReactNode;
  RightComponents?: ReactNode;
}

const CustomTabsV3 = ({
  tabs,
  children,
  lazyMount,
  variant = "enclosed",
  unmountOnExit,
  value,
  className,
  classNameList,
  defaultValue,
  RightComponents,
  onValueChange,
}: ICustomTabsV3) => {
  return (
    <Tabs.Root
      lazyMount={lazyMount}
      unmountOnExit={unmountOnExit}
      variant={variant}
      defaultValue={defaultValue}
      value={value}
      onValueChange={onValueChange}
      className={classNames(style.container, className)}
    >
      <div className="d-flex w-100 align-items-center justify-content-between">
        <Tabs.List className={style.listContainer}>
          {tabs.map((tab) => {
            return (
              <Tabs.Trigger
                key={tab.label}
                value={tab.value}
                className={classNames(style.containerTab, classNameList)}
              >
                {tab.icon && tab.icon}
                {tab.label}
                {tab.hasError && <span className={style.errorDot} />}
              </Tabs.Trigger>
            );
          })}
          <Tabs.Indicator rounded={"100px"} />
        </Tabs.List>
        {RightComponents}
      </div>
      {children}
    </Tabs.Root>
  );
};

export default CustomTabsV3;
